import { useMutation } from '@tanstack/react-query';
import { saveDraft } from '../../services';

export function useSaveDraft() {
  return useMutation(saveDraft, { onSuccess: (data) => data });
}
